import { Brand } from '@blade/std-lib'

export const TokenLogosHostTypeId = 'tradebot-tma/TokenLogosHost'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TokenLogosHostTypeId = typeof TokenLogosHostTypeId

export type TokenLogosHost = Brand.Branded<string, TokenLogosHostTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TokenLogosHost = Brand.nominal<TokenLogosHost>()
